export default {
  index: [
    {
      path: '/userbz',
      component: resolve => require(['./userbzIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/user_bz/_router.js